// Types supported inside a group with appearance_aecom='table' (see tableGroup.vue).
// key   = type as found in the form definition
// value = type of the html input used by tableCell.vue
export default {
  text: 'text',
  string: 'text',
  integer: 'number',
  decimal: 'number',
  number: 'number',
}
